module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Nicci French\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('B', [_vm._v("Nicci French")]), _vm._v(" is the author of "), _c('I', [_vm._v("Catch Me When I Fall, Secret Smile, Land of the Living, Killing Me Softly, The Red Room,")]), _vm._v(" and "), _c('I', [_vm._v("Beneath the Skin")]), _vm._v(". She lives near Ipswich, England.")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/CD2Ld3/tc-custom/9780759525382.jpg?1738126545176",
      "alt": "This image is the cover for the book Beneath the Skin"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Beneath the Skin\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('b', [_vm._v("“An absolutely first rate thriller” from the author of ")]), _c('i', [_c('b', [_vm._v("Killing Me Softly ")])]), _c('b', [_vm._v("about three women being terrorized by the same stalker.")]), _c('br'), _c('br'), _vm._v("Zoe. Jenny. Nadia. Three women of varying ages and backgrounds with little else in common but for one thing: Someone has sent them each a note informing them that they will be killed. A cruel joke? A hoax? The police don't seem to think so. Now, with no clear suspect and amid the growing threat of violence, the victims become the accused as authorities dig into their backgrounds for clues as to why they might have attracted the unrelenting attention of a killer. As Zoe, Jenny, and Nadia find themselves being victimized twiceover, once by the faceless stalker and again by the police, each must ultimately face the question of which is stronger: the instinct to survive, or the desire to destroy?")]), _c('p', [_vm._v("“Powerfully intricate.” —"), _c('i', [_vm._v("Publishers Weekly")])]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Grand Central Publishing\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5610da35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0